(function () {
    'use strict';

    angular
        .module('blocks.formly')
        .factory('formlyService', formlyService);

    /* @ngInject */
    function formlyService(logger, formlyValidationMessages, formlyConfig, appApiCheck) {
        var service = {
            initFormly: initFormly
        };

        return service;

        function initFormly() {
            // NOTE: This next line is highly recommended.
            // Otherwise Chrome's autocomplete will appear over your options!
            formlyConfig.extras.removeChromeAutoComplete = true;
            formlyConfig.extras.defaultHideDirective = 'ng-show';
            setupValidationMessages();
            setupControls();
        }

        function setupValidationMessages() {
            formlyValidationMessages.addStringMessage('required', 'This field is required');
            formlyValidationMessages.addStringMessage('Email', 'This field is not a valid Email');
            formlyValidationMessages.addStringMessage('maxlength', 'This field is to long');
        }

        function setupControls() {
            createFormlyDatePicker();
            createFormlyButton();
            createFormlySelects();
            createFormlyTypeAhead();
            createFormlyToggle();
            createFormlyInputAlert();
        }

        function datePickerAttributes() {
            return [
                'date-disabled',
                'custom-class',
                'show-weeks',
                'starting-day',
                'init-date',
                'min-mode',
                'max-mode',
                'format-day',
                'format-month',
                'format-year',
                'format-day-header',
                'format-day-title',
                'format-month-title',
                'year-range',
                'shortcut-propagation',
                'datepicker-popup',
                'show-button-bar',
                'current-text',
                'clear-text',
                'close-text',
                'close-on-date-selection',
                'datepicker-append-to-body'
            ];
        }

        function datePickerBindings() {
            return [
              'datepicker-mode',
              'min-date',
              'max-date'
            ];
        }

        function createFormlyDatePicker() {
            var attributes = datePickerAttributes();

            var bindings = datePickerBindings();

            var ngModelAttrs = {};

            angular.forEach(attributes, function (attr) {
                ngModelAttrs[camelize(attr)] = { attribute: attr };
            });

            angular.forEach(bindings, function (binding) {
                ngModelAttrs[camelize(binding)] = { bound: binding };
            });

            logger.info('Formly Date picker', ngModelAttrs);

            formlyConfig.setType({
                name: 'datepicker',
                templateUrl: 'app/blocks/formly-controls/DatePicker.html',
                wrapper: ['bootstrapLabel', 'bootstrapHasError'],
                defaultOptions: {
                    ngModelAttrs: ngModelAttrs,
                    templateOptions: {
                        datepickerOptions: {
                            format: 'MM/dd/yyyy',
                            initDate: new Date()
                        }
                    }
                },
                controller: ['$scope', function ($scope) {
                    $scope.datepicker = {};

                    $scope.datepicker.opened = false;

                    $scope.datepicker.open = function () {
                        $scope.datepicker.opened = !$scope.datepicker.opened;
                    };
                }]
            });
        }

        function createFormlyToggle() {
            formlyConfig.setType({
                name: 'toggle',
                templateUrl: 'app/blocks/formly-controls/toggle.html',
                wrapper: ['bootstrapHasError'],
                defaultOptions: {
                    templateOptions: {
                        label: '',
                        activeText: 'Active',
                        inactiveText: 'Inactive'
                    }
                },
                apiCheck: function (check) {
                    return {
                        templateOptions: {
                            label: check.string,
                            activeText: check.string,
                            inactiveText: check.string
                        }
                    };
                },
                apiCheckInstance: appApiCheck
            });
        }

        function createFormlyInputAlert() {
            formlyConfig.setType({
                name: 'alert-input',
                templateUrl: 'app/blocks/formly-controls/alert-input.html',
                wrapper: ['bootstrapHasError'],
                defaultOptions: {
                    templateOptions: {
                        label: '',
                        placeholder: '',
                        required: false,
                        disabled: false,
                        alertMessage: '',
                        alertType: 'warn',
                        alertColor: '#8a6d3b'
                    }
                }                
            });
        }

        function createFormlyButton() {
            formlyConfig.setType({
                name: 'button',
                template: '<button type="{{::to.type}}" ' +
                    'class="btn btn-{{::to.btnType}}" ' +
                    'ng-click="onClick($event)">{{to.text}}</button>',
                wrapper: [],
                defaultOptions: {
                    templateOptions: {
                        btnType: 'default',
                        type: 'button'
                    },
                    extras: {
                        // perf optimization because this type has no ng-model
                        skipNgModelAttrsManipulator: true
                    }
                },
                controller: ['$scope', function ($scope) {
                    $scope.onClick = onClick;

                    function onClick($event) {
                        if (angular.isString($scope.to.onClick)) {
                            return $scope.$eval($scope.to.onClick, { $event: $event });
                        } else {
                            return $scope.to.onClick($event, $scope.originalModel);
                        }
                    }
                }],
                apiCheck: function (check) {
                    return {
                        templateOptions: {
                            onClick: check.oneOfType([check.string, check.func]),
                            type: check.string.optional,
                            btnType: check.string.optional,
                            text: check.string
                        }
                    };
                },
                apiCheckInstance: appApiCheck
            });
        }

        function createFormlySelects() {
            // Configure custom types
            formlyConfig.setType({
                name: 'ui-select-single',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-single.html'
            });
            // Configure custom types
            formlyConfig.setType({
                name: 'ui-select-single-group',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-single-group.html'
            });
            formlyConfig.setType({
                name: 'ui-select-single-select2',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-single-select2.html'
            });
            formlyConfig.setType({
                name: 'ui-select-single-search',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-single-async-search.html'
            });

            formlyConfig.setType({
                name: 'ui-select-multiple',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-multiple.html'
            });

            formlyConfig.setType({
                name: 'ui-select-infinite',
                extends: 'select',
                templateUrl: 'app/blocks/formly-controls/ui-select-infinite.html',
                defaultOptions: {
                    templateOptions: {
                        load: function () { },
                        loadMore: true,
                        pageCount: 10
                    }
                },
                apiCheck: function (check) {
                    return {
                        templateOptions: {
                            load: check.func,
                            loadMore: check.bool,
                            pageCount: check.number
                        }
                    };
                },
                controller: ['$scope', function ($scope) {
                    $scope.onLoad = onLoad;
                    $scope.to.options = $scope.to.options || [];
                    $scope.count = 0;
                    $scope.to.page = 0;

                    function onLoad($select, $event) {
                        if (!$event) {
                            $scope.to.page = 0;
                            $scope.to.options = [];
                        } else {
                            $event.stopPropagation();
                            $event.preventDefault();
                            $scope.to.page++;
                        }

                        $scope.loading = true;

                        return $scope.to.load($event, $select, $scope.originalModel,
                            $scope.to.page, $scope.to.pageCount)
                            .then(function (result) {

                                $scope.count = result.count;

                                $scope.to.options = $scope.to.options.concat(result);
                                $scope.loading = false;
                                return result;
                            });
                    }
                }],
                apiCheckInstance: appApiCheck
            });
        }

        function createFormlyTypeAhead() {
            formlyConfig.setType({
                name: 'typeahead-async',
                template:
                    '<input type="text" ' +
                        'ng-model="model[options.key]"  ng-style="to.style" typeahead-no-results="noResults"' +
                        ' typeahead-loading="loading" ' +
                         'uib-typeahead="item as item[to.display] for item in to.options($viewValue)" ' +
                        'class="form-control">' +
                        ' <span class="fa fa-refresh error-loader" ng-show="loading"></span> ' +
                        '<div ng-show="noResults">' +
                        '<i class="glyphicon glyphicon-remove"></i> No Results Found' +
                        '</div>',
                wrapper: ['bootstrapLabel', 'bootstrapHasError']
            });
        }

        function camelize(string) {
            string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
                return chr ? chr.toUpperCase() : '';
            });
            // Ensure 1st char is always lowercase
            return string.replace(/^([A-Z])/, function (match, chr) {
                return chr ? chr.toLowerCase() : '';
            });
        }
    }
}());
